// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"573a9d91","400":"e8ebcb37","453":"40a63f55","667":"251e58af"}[chunkId] + ".chunk.js";
};